import * as PensionProvidersList from './../actions/pension-providers-list.action';

export type Actions = PensionProvidersList.Actions;


export function PensionProvidersListReducer(state = [], action: PensionProvidersList.Actions) {
    switch (action.type) {
        case PensionProvidersList.ADD_PENSION_PROVIDERS_LIST:
            return [...state, action.payload];
        // Add this case:
        case PensionProvidersList.REMOVE_PENSION_PROVIDERS_LIST:
            state = [];
            return state;

        default:
            return state;
    }
}
